import firebase from 'firebase';
import { uploadFileToStorage } from './storage';

export async function getPhotosLanding() {
    let response = await firebase.firestore().collection("photosLanding").orderBy("orden","asc").get().catch(error => console.log(`Error obtener photoa landing: ${JSON.stringify(error)}`));
    let photos = response.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    return photos
}